import { createContext, useContext } from 'react';
import { TimezoneProvider, ToastProvider } from '@facephi/ui-react';
import { ApiProvider } from './ApiProvider';
import { TranslationProvider } from './TranslationProvider';

type Props = {
  children: React.ReactNode;
  language: string;
  apiUrl: string;
  token?: string;
  onUserOperation?: (id: string) => void;
  timezone?: string;
};

type ContextProps = {
  apiUrl: string;
  token?: string;
  onUserOperation?: (id: string) => void;
  timezone?: string;
};

const Ctx = createContext<ContextProps>({
  apiUrl: '',
  token: '',
  timezone: '',
});

export const CiamProvider = ({
  children,
  language,
  apiUrl,
  token,
  onUserOperation,
  timezone,
}: Props) => {
  return (
    <Ctx.Provider value={{ apiUrl, token, onUserOperation, timezone }}>
      <TranslationProvider language={language}>
        <TimezoneProvider locale={language} timezone={timezone}>
          <ToastProvider>
            <ApiProvider>{children}</ApiProvider>
          </ToastProvider>
        </TimezoneProvider>
      </TranslationProvider>
    </Ctx.Provider>
  );
};

export const useCiam = () => useContext(Ctx);
